import { useAuthContext } from "@/context/auth/useAuthContext";
import Iconify from "../../Iconify";

const IconButton = ({
  className,
  children,
  icon,
  iconClass,
  onClick,
  notifTooltip,
  msgTooltip,
}) => {
  const { totalUnreadNotifications, totalUnreadMessageCount } =
    useAuthContext();

  return (
    <button
      className={`flex items-end gap-3 py-3 px-3 md:px-5 !leading-4 font-semibold dark:text-white text-light_primary_label dark:hover:bg-dark_bg_grey hover:bg-light_bg_grey outline-none rounded-full ${className}`}
      name="btn"
      onClick={onClick}
    >
      {icon && (
        <div className="relative flex h-5 w-5 shrink-0 items-center justify-center">
          <IconForButton icon={icon} iconClass={iconClass} />
          {notifTooltip &&
            !!totalUnreadNotifications &&
            totalUnreadNotifications > 0 && (
              <span className="bg-red text-white absolute -top-3.5 -right-2.5 rounded-full w-4 h-4 flex items-center justify-center text-xs z-10">
                {totalUnreadNotifications}
              </span>
            )}

          {msgTooltip &&
            !!totalUnreadMessageCount &&
            totalUnreadMessageCount > 0 && (
              <span className="bg-red text-white absolute -top-3.5 -right-2.5 rounded-full w-4 h-4 flex items-center justify-center text-xs z-10">
                {totalUnreadMessageCount}
              </span>
            )}
        </div>
      )}
      <span className="!leading-4 mb-[3px]">{children}</span>
    </button>
  );
};

export default IconButton;

const IconForButton = ({ icon, iconClass }) => {
  if (icon === "custom_place_icon")
    return (
      <img
        src="/camera-icon.png"
        alt="camera"
        className={`w-5 h-5 object-contain dark:invert ${iconClass}`}
      />
    );
  if (icon === "custom_play_icon")
    return (
      <span
        className={`block h-5 w-5 bg-current ${iconClass}`}
        aria-hidden="true"
        style={{
          WebkitMask:
            "url(/icons/mobile-nav/cicle-play.svg) center / contain no-repeat",
          mask: "url(/icons/mobile-nav/cicle-play.svg) center / contain no-repeat",
        }}
      />
    );
  return <Iconify icon={icon} className={iconClass} />;
};
